import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CancelledAndDestroyedTable from "components/Tables/CancelledAndDestroyedTable";

export default function CancelledAndDestroyedPage() {
  return (
    <>
      <Container fluid>
        <Row>
          <Col lg="12" sm="12" md="12">
            <CancelledAndDestroyedTable />
          </Col>
        </Row>
      </Container>
    </>
  );
}
